import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { getNotificationApi, markReadNotificationApi } from "./Notification.api";
import { useAuth } from "context/auth-context";
import { useTranslation } from "react-i18next";
import { FiBell, FiGift } from "react-icons/fi";
import { EmptyState } from "components/ui";
import { NotificationRow } from "./NotificationRow";

const PointUIModel = ({ activeTab }: any) => {
  const { auth } = useAuth();
  const { t } = useTranslation();
  const type = "point";
  const queryClient = useQueryClient();

  // Fetch notifications with proper dependency on activeTab
  const { data } = useQuery(
    ["notification", auth.panelistId, type],
    () => getNotificationApi(auth.panelistId, type),
    {
      refetchOnWindowFocus: false,
    }
  );
  // Mark notifications as read
  const markAsReadMutation = useMutation(
    (notificationIds: number[]) => markReadNotificationApi(auth.panelistId, notificationIds, type),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["notification", auth.panelistId, type]);
      },
    }
  );

  useEffect(() => {
    return () => {
      // Only execute when leaving the "Survey" tab
      if (data?.NotificationData) {
        const unreadNotifications = data.NotificationData.filter(
          (notification: any) => !notification.mark_as_read
        );
        if (unreadNotifications.length > 0) {
          const unreadIds = unreadNotifications.map((notification: any) => notification.id);
          markAsReadMutation.mutate(unreadIds);
        }
      }
    };
  }, [activeTab, data?.NotificationData]);

  return (
    <div>
      <div className="flex flex-col gap-1">
        {data?.NotificationData?.length > 0 ? (
          data?.NotificationData?.map((notification: any) => (
            <NotificationRow
              key={notification.id}
              icon={<FiGift className="w-4 h-4" />}
              message={notification.message}
              createdAt={notification.created_at}
              unread={notification.mark_as_read === 0}
            />
          ))
        ) : (
          <EmptyState icon={<FiBell />} title={t("point.notification.available")} className="!py-10" />
        )}
      </div>
    </div>
  );
};

export default PointUIModel;
